<router-outlet></router-outlet>
<app-loader></app-loader>
<app-error-alert-popup></app-error-alert-popup>
<app-error-alert-popup-ctba></app-error-alert-popup-ctba>

